import { Routes } from '@angular/router';
import { isAdmin } from '../../../common/services/guards/is-admin.guard';
import { isFrontend } from '../../../common/services/guards/is-frontend.guard';
import { isSessionValid } from '../../../common/services/guards/is-session-valid.guard';
import { isSurveyAvailable } from '../../../survey/src/app/shared/guard/is-survey-available.guard';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { LoginComponent } from './components/login/login.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { RootComponent } from './components/root.component';

export const routes: Routes = [
    {
        path: '',
        component: RootComponent,
        data: {
            prefixTitle: 'Authentification',
        },
        children: [
            {
                path: '',
                component: LoginComponent,
            },
            {
                path: 'changer-mot-de-passe',
                component: ChangePasswordComponent,
            },
            {
                path: 'reinitialiser-mot-de-passe',
                component: ResetPasswordComponent,
            },
        ],
    },
    {
        path: 'backend',
        loadChildren: () => import('../../../backend/src/app/app.module').then(m => m.AppModule),
        canMatch: [
            isSessionValid,
            isAdmin,
        ],
        data: {
            prefixTitle: 'Administration',
        },
    },
    {
        path: 'portail',
        loadChildren: () => import('../../../portal/src/app/app.module').then(m => m.AppModule),
        canMatch: [
            isSessionValid,
            isFrontend,
        ],
        data: {
            prefixTitle: 'Portail D\'Clic',
        },
    },
    {
        path: 'survey',
        loadChildren: () => import('../../../survey/src/app/app.module').then(m => m.AppModule),
        canMatch: [
            isSessionValid,
            isSurveyAvailable,
            isFrontend,
        ],
        data: {
            prefixTitle: 'Enquête de satisfaction D\'Clic',
        },
    },
];
